export default [
  {
    path: "/backoffice/bank/bank-accounts",
    name: "BankAccounts",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Accounts" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/ChartOfAccounts.vue"
      ),
  },
  {
    path: "/backoffice/bank/bank-accounts/create",
    name: "BankAccountsCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Accounts", to: "/backoffice/bank/bank-accounts" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Aid/AddGLAccount/AddGLAccount.vue"
      ),
  },
  {
    path: "/backoffice/bank/journals",
    name: "JournalEntriesList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Journals" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/JournalEntriesList.vue"
      ),
  },
  {
    path: "/backoffice/bank/journals/create",
    name: "JournalEntriesCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Journals", to: "/backoffice/bank/journals" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/JournalEntriesCreate/JournalEntriesCreate.vue"
      ),
  },
  {
    path: "/backoffice/bank/journals/transactions/:id",
    name: "TransactionView",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Journal Entries", to: "/backoffice/bank/journals" },
        { label: "Transactions" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/TransactionView/TransactionView.vue"
      ),
  },
  {
    path: "/backoffice/bank/bank-products-create",
    name: "BankProductsCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Products", to: "/backoffice/bank/bank-products-list" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/BankProductCreate.vue"
      ),
  },
  {
    path: "/backoffice/bank/bank-products-list",
    name: "BankProducts",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Products" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/BankProductsList/BankProductsList.vue"
      ),
  },
  {
    path: "/backoffice/bank/bank-product/:id",
    name: "BankProductDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Products", to: "/backoffice/bank/bank-products-list" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/BankProductCreate.vue"
      ),
  },
  {
    path: "/backoffice/bank/bank-product/:id/edit",
    name: "BankProductEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Bank" },
        { label: "Products", to: "/backoffice/bank/bank-products-list" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "bank" */ "@/views/backoffice/Bank/BankProductCreate.vue"
      ),
  },
];
